module.exports = __webpack_public_path__ + "static/media/linha.5c1df482.svg";